import { render, staticRenderFns } from "./question-input.vue?vue&type=template&id=aae84d5e&scoped=true&"
import script from "./question-input.vue?vue&type=script&lang=js&"
export * from "./question-input.vue?vue&type=script&lang=js&"
import style0 from "./question-input.vue?vue&type=style&index=0&id=aae84d5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae84d5e",
  null
  
)

export default component.exports